import { Modal } from '@trussworks/react-uswds';
import { ModalHeader } from '.';
import { useModal } from '@stores';
import useListener from '@hooks/useListener';
import classNames from 'classnames';
import '@components/modal/modal.scss';

const sizeMap = {
  sm: false,
  md: true,
  lg: true,
};

const ModalContent = ({
  children,
  className = '',
  hasCloseButton = false,
  hasIcon = false,
  isError = false,
  size = 'lg',
  title,
  ...customProps
}) => {
  const { closeSecondaryModal } = useModal();
  const modalClasses = classNames(className, size === 'md' && 'modal-md');

  useListener(
    'keyup',
    (e) => {
      e.stopPropagation();

      if (hasCloseButton && e.key === 'Escape') {
        closeSecondaryModal();
      }
    },
    window,
    { passive: false, capture: true }
  );

  useListener('click', (e) => {
    const isOverlayClick = e.target.getAttribute('data-testId') === 'modalOverlay';
    const isCloseBtnClick = e.target.getAttribute('data-close-modal') === 'true';
    const isSecondaryModal = !!e.target?.closest('[role=dialog]')?.querySelector('[data-secondary-modal]');

    if (isSecondaryModal && hasCloseButton && (isOverlayClick || isCloseBtnClick)) {
      closeSecondaryModal();
    }
  });

  return (
    <Modal
      aria-describedby='secondary-modal-content'
      aria-labelledby='secondary-modal-header'
      className={modalClasses}
      data-secondary-modal='true'
      forceAction={!hasCloseButton}
      isInitiallyOpen
      isLarge={sizeMap[size || 'lg']}
      {...customProps}
    >
      <ModalHeader hasIcon={hasIcon} isError={isError} title={title} />
      <div id='secondary-modal-content'>{children}</div>
    </Modal>
  );
};

export default ModalContent;
